import Page from 'Layouts/AuthBaseLayout/Components/Page'
import { useHTMLTitle } from 'Utils/useHTMLTitle'
import { PageHeader } from '@ant-design/pro-layout'
import { Result, Button } from 'antd'
import { SmileOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

const emptyPageProps = {
  style: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 'calc(100vh - 10rem)',
  },
}
const ComingSoonLayout = ({ title }: { title: string }) => {
  useHTMLTitle(title)
  return (
    <Page header={<PageHeader title={title} />} contentProps={emptyPageProps}>
      <Result
        icon={<SmileOutlined />}
        title="Coming soon!"
        extra={
          <Button type="primary">
            <Link to="../../">Go Home</Link>
          </Button>
        }
      />
    </Page>
  )
}

export default ComingSoonLayout
